import { FC } from 'react';

interface Props {
  percent: number;
}
type ProgressBarProps = Props;

const ProgressBar: FC<ProgressBarProps> = ({ percent }) => {
  return (
    <div className="flex-col">
      <div className="rounded-[5px] h-[6px] mx-6 mt-5 mb-3 bg-gray-100">
        <div className="rounded-[5px] bg-violet-600 h-[6px] relative duration-1000" style={{ width: `${percent}%`, transition: 'width 0.1s ease-in-out' }}>
          <div className="text-violet-600 font-bold text-[10px] text-right absolute -right-3 -top-5">{Math.floor(percent)}%</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
